import { render, staticRenderFns } from "./RulesEditor.vue?vue&type=template&id=5d229604&scoped=true"
import script from "./RulesEditor.vue?vue&type=script&lang=js"
export * from "./RulesEditor.vue?vue&type=script&lang=js"
import style0 from "./RulesEditor.vue?vue&type=style&index=0&id=5d229604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d229604",
  null
  
)

export default component.exports